export enum EDestinationLineType {
    LANDLINE = 'landline',
    CELLULAR = 'cellular',
    UNKNOWN = 'unknown', // number plans like +1 do not tell landline from cellular
}

export const destinationLineTypeAsString = (lineType: EDestinationLineType | string): string => {
    switch (lineType) {
        case EDestinationLineType.LANDLINE:
            return "Fixe";
        case EDestinationLineType.CELLULAR:
            return "Mobile";
        case EDestinationLineType.UNKNOWN:
            return "Type indéterminé";
        default:
            return lineType.toString();
    }
};